let next = 0;

/** Identificatore univoco nella pagina, per collegare etichette, aiuti ed errori ai campi. */
export function uniqueId(prefix: string): string {
  next += 1;
  return `${prefix}-${next}`;
}
